var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStagePersisted = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "stage-persisted__a",
    d: "M23.795 18.744c1.219 0 2.205.79 2.205 1.756 0 3.61-6.54 5.5-13 5.5S0 24.11 0 20.5c0-.967.987-1.75 2.205-1.75s2.205.783 2.205 1.75c.171.589 3.302 1.999 8.59 1.999s8.419-1.41 8.592-2.011c0-.967.986-1.744 2.203-1.744zm0-7.5c1.219 0 2.205.79 2.205 1.756 0 3.61-6.54 5.5-13 5.5S0 16.61 0 13c0-.966.987-1.75 2.205-1.75S4.41 12.034 4.41 13c.171.59 3.302 2 8.59 2s8.419-1.41 8.592-2.012c0-.967.986-1.744 2.203-1.744zM13 0C19.46 0 26 1.89 26 5.5c0 3.612-6.54 5.5-13 5.5S0 9.113 0 5.5C0 1.89 6.54 0 13 0zm0 3.501c-5.287 0-8.418 1.41-8.59 2.011C4.58 6.09 7.71 7.5 12.998 7.5c5.254 0 8.378-1.391 8.588-2-.21-.608-3.334-1.999-8.588-1.999z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "stage-persisted__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stage-persisted__a"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stage-persisted__a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H26V26H0z",
    mask: "url(#stage-persisted__b)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStagePersisted);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/stage-persisted.d118584dc80ec98920effaf562bc79ca.svg";